export const validateEmailAddress = (emailAddress) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(emailAddress);

